import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { PriceService, PricingModel, PricingStatusEnum } from "@app/modules/tf-pricing";
import { ProductSiteRegionService } from '@app/services/product-site-region.service';
import { Subscription } from "rxjs";
import { TfUserDataService } from "@app/modules/tf-user-data";

@Component({
    selector: 'tf-price',
    templateUrl: './price.component.html',
    styleUrls: ['./price.component.scss']
})
export class TfPriceComponent implements OnInit, OnChanges, OnDestroy {

    @Input() sku: string = null;
    @Input() seeInCart: boolean = false;
    @Input() classesPriceLabel: string[] = [];

    @ViewChild('loginContent') loginContent: TemplateRef<string>;
    @ViewChild('bestPriceContent') bestPriceContent: TemplateRef<string>;

    pricingData: PricingModel = null;

    isUserLoggedIn: boolean = false;

    readonly PricingStatusEnum = PricingStatusEnum;
    pricingStatus: PricingStatusEnum = null;

    private subscriptions = new Subscription();

    constructor(
        private priceService: PriceService,
        private userDataService: TfUserDataService,
        private readonly productSiteRegionService: ProductSiteRegionService
    ) {
    }

    ngOnInit(): void {

        const userSubscription = this.userDataService.getUserDetailsObservable().subscribe((userDetails) => {
            this.isUserLoggedIn = userDetails.isLoggedIn;
        });

        this.subscriptions.add(userSubscription);

        this.pricingStatus = PricingStatusEnum.loading;

        const priceSubscription = this.priceService.getPreloadedPricing(this.sku).subscribe({
            next: (value) => {
                this.pricingData = value;
                this.pricingStatus = PricingStatusEnum.done;
            },
            error: (err) => {
                console.log(err);
            }
        });

        this.subscriptions.add(priceSubscription);

    }

    ngOnChanges(changes: SimpleChanges): void {

        if (changes['sku'] && changes['sku'].firstChange === false) {

            if (this.seeInCart) {
                return;
            }

            this.pricingStatus = PricingStatusEnum.loading;

            this.priceService.getPricing(changes['sku'].currentValue, this.isUserLoggedIn).subscribe((data) => {
                this.pricingData = data;
                this.pricingStatus = PricingStatusEnum.done;
            });

        }

    }

    // displayMyPrice(): boolean {
    //     if (this.pricingStatus === PricingStatusEnum.done && this.pricingData) {
    //         return this.pricingData?.displayMyPrice(this.isUserLoggedIn);
    //     }
    //     return false;
    // }


    showStrikeOutPrice(): boolean {
       return this.pricingData.showStrikeOutPrice();
    }

    getPopOverContent(): TemplateRef<string> {
        return this.isUserLoggedIn ? this.bestPriceContent : this.loginContent;
    }

    getFinalPrice(): string {

        if (this.seeInCart) {
            return "See in Cart";
        }

        if (!this.pricingData) {
            return "Price not available";
        }

        return this.pricingData?.getFinalPrice(this.isUserLoggedIn);

    }

    isSpecialOffer(): boolean {
        return this.pricingData?.pricingDetails?.priceRuleType === "SPECIALOFFER";
    }

    getPromoEndDate(): string {
        return this.pricingData?.getPromoEndDate() || '';
    }

    getSavings(): string {
        return this.pricingData?.getSavings() || ''
    }

    isOnlinePriceBest(): boolean {
        return (this.pricingData?.pricingDetails?.priceRuleType === "ONLINE" && this.pricingData?.pricingDetails?.onlinePriceApplicable) || this.isSpecialOffer();
    }

    isOnlineSecondBest(): boolean {
        return this.pricingData?.pricingDetails?.secondBestPriceType?.toUpperCase() === "ONLINE";
    }

    getStrikeOutPrice(): string {
        return this.pricingData?.getStrikeOutPrice();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    signIn() {
        if (this.userDataService.getIsLoggedInValue() === false) {
            this.userDataService.login();
        }
    }

    isLoggedIn(): boolean {
        return this.userDataService.getIsLoggedInValue();
    }

    getCurrency(): string {
        if (this.isLoggedIn() && this.productSiteRegionService.isThermofisher()) {
            return this.userDataService?.getCurrencyCode();
        } else {
            return this.priceService?.getAnonymousCurrencyCode();
        }
    }

    getBrandColor(): string {
        return this.productSiteRegionService.isFisherSci() ? "#0071D0" : "#e71316";
    }

    getSecondBestPrice(): string {
        return this.pricingData?.getSecondBestPrice();
    }

    getBestPricePopoverContent(): string {
        const bestPriceSrc = this.pricingData?.pricingDetails?.priceRuleType;

        switch (bestPriceSrc?.toUpperCase()) {
            case 'ONLINE':
                return 'Online price is your best price.';
            case 'SPECIALOFFER':
                return 'Special offer is your best price.';
            case 'ACCOUNT':
                return 'Account price is your best price.';
            case 'LIST':
            default:
                return 'This is your best price';
        }

    }

}
